import React from 'react'
import './index.scss'

export default function Title({title}) {
  return (
    <div className='comp-title'>{title}</div>
  )
}
